import {React, Component} from 'react';
import './loadingSymbol.css';

export default class LoadingSymbol extends Component {
    render() {
        return (
            <div className="skCircle">
                <div className="skCircle1 skChild"></div>
                <div className="skCircle2 skChild"></div>
                <div className="skCircle3 skChild"></div>
                <div className="skCircle4 skChild"></div>
                <div className="skCircle5 skChild"></div>
                <div className="skCircle6 skChild"></div>
                <div className="skCircle7 skChild"></div>
                <div className="skCircle8 skChild"></div>
                <div className="skCircle9 skChild"></div>
                <div className="skCircle10 skChild"></div>
                <div className="skCircle11 skChild"></div>
                <div className="skCircle12 skChild"></div>
            </div>
        );
    }
}